import { useFeature } from '@mafc/appshell';

const useLbpToUsd = () => {
  return useFeature('checkout.lbp-to-usd-conversion.enabled').value;
};

export default useLbpToUsd;
